import './App.css';
import './i18n';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';

import Home from './pages/Home';
import Contact from './pages/Contact';
import EmpezarPage from './pages/EmpezarPage';
import Portfolio from './pages/Portfolio';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import About from './pages/About';
import NotFound from './pages/NotFound';
import ServicePage from './pages/ServicePage';
import ConsultingPage from './pages/ConsultingPage';
import ContentCreationPage from './pages/ContentCreationPage';
import SocialMediaPage from './pages/SocialMediaPage';
import PodcastPage from './pages/PodcastPage';
import CoursesPage from './pages/CoursesPage';
import CuandoSaleElSol from './pages/clients/CuandoSaleElSol';
import LaGachaGate from './pages/clients/LaGachaGate';

import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminBlog from './pages/admin/AdminBlog';
import AdminCases from './pages/admin/AdminCases';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminContacts from './pages/admin/AdminContacts';

const showCuandoSaleElSol = process.env.REACT_APP_SHOW_CUANDO_SALE_EL_SOL === 'true';

function NoIndexNotFound() {
  useEffect(() => {
    let metaRobots = document.querySelector('meta[name="robots"]');
    const created = !metaRobots;

    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.name = 'robots';
      document.head.appendChild(metaRobots);
    }

    const previousContent = metaRobots.content;
    metaRobots.content = 'noindex,nofollow';

    return () => {
      if (created) document.head.removeChild(metaRobots);
      else metaRobots.content = previousContent;
    };
  }, []);

  return <NotFound />;
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/portafolio" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/acerca" element={<About />} />
          <Route path="/podcast" element={<PodcastPage />} />
          <Route path="/cursos" element={<CoursesPage />} />
          <Route path="/contacto" element={<Contact />} />

          {/* Service offer pages */}
          <Route path="/servicios/:serviceKey" element={<ServicePage />} />

          {/* Campaign landing pages */}
          <Route path="/empezar" element={<EmpezarPage />} />
          <Route path="/consulting" element={<ConsultingPage />} />
          <Route path="/content-creation" element={<ContentCreationPage />} />
          <Route path="/social-media" element={<SocialMediaPage />} />

          {/* Client decks (noindex) */}
          <Route
            path="/clients/cuando-sale-el-sol"
            element={showCuandoSaleElSol ? <CuandoSaleElSol /> : <NoIndexNotFound />}
          />
          {/* Unlisted deck: /clients/<secret>. The secret is not in this file (only its hash is, in LaGachaGate). Static client folders and cuando-sale-el-sol match first. */}
          <Route path="/clients/:deckToken" element={<LaGachaGate />} />

          {/* Admin login */}
          <Route path="/admin" element={<AdminLogin />} />

          {/* Admin protected routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="cases" element={<AdminCases />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="contacts" element={<AdminContacts />} />
          </Route>

          {/* 404 catch-all */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
